import {
  GridColDef,
  GridColumnGroupingModel,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { ColumnVisibilitySelect } from '~/components/ColumnVisibilitySelect/ColumnVisibilitySelect';

import { alignColumnDefinitions } from './ColumnSelector.util';

export interface ColumnSelectorProps<R extends GridValidRowModel = any> {
  columns: GridColDef<R>[];
  columnGroupingModel?: GridColumnGroupingModel;
  columnVisibilityModel?: GridColumnVisibilityModel;
  onColumnVisibilityModelChange?: (model: GridColumnVisibilityModel, details: any) => void;
}

export const ColumnSelector = <R extends GridValidRowModel = any>({
  columns,
  columnGroupingModel,
  columnVisibilityModel,
  onColumnVisibilityModelChange,
}: ColumnSelectorProps<R>) => {
  const { t } = useTranslation();

  const { alignedColumns, alignedColumnGroups } = alignColumnDefinitions(columns, columnGroupingModel);

  const handleItemToggle = (name: string) => {
    if (columnVisibilityModel && onColumnVisibilityModelChange) {
      onColumnVisibilityModelChange(
        {
          ...columnVisibilityModel,
          [name]: columnVisibilityModel[name] === false,
        },
        undefined,
      );
    }
  };

  return (
    <ColumnVisibilitySelect
      tooltip={t('Base.common.columnVisibilityTooltip')}
      items={alignedColumnGroups ?? alignedColumns}
      getItemChecked={(itemName) => (columnVisibilityModel ? columnVisibilityModel[itemName] !== false : true)}
      onItemToggle={handleItemToggle}
    />
  );
};
